module.exports = __webpack_public_path__ + "img/logo-ecopetrol-w.deaba036.png";